"use client";

import React, { createContext, useContext, ReactNode } from "react";
import { APYData } from "../types";

type APYContextType = APYData;

const APYContext = createContext<APYContextType | undefined>(undefined);

interface APYProviderProps {
  // Fetched on the server in the root layout (see ../server.ts)
  rates: APYData;
  children: ReactNode;
}

export function APYProvider({ rates, children }: APYProviderProps) {
  return <APYContext.Provider value={rates}>{children}</APYContext.Provider>;
}

export function useAPYContext(): APYContextType {
  const context = useContext(APYContext);
  if (context === undefined) {
    throw new Error("useAPYContext must be used within an APYProvider");
  }
  return context;
}
